// Activities Widget Tab Constants

export const WIDGET_TABS = {
  LIST: "list",
  CREATE: "create",
};
